const OVERLAY_Z = 1299
const OVERLAY_BG = 'rgba(0, 0, 0, 0.55)'
const GAP = 4

export const TourSpotlight = ({ targetElement, show }) => {
  if (!show) return null

  const rect = targetElement ? targetElement.getBoundingClientRect() : null

  const hole = rect
    ? {
        top: rect.top - GAP,
        left: rect.left - GAP,
        right: rect.right + GAP,
        bottom: rect.bottom + GAP
      }
    : null

  if (!hole) {
    return (
      <div
        style={{
          position: 'fixed',
          inset: 0,
          backgroundColor: OVERLAY_BG,
          pointerEvents: 'none',
          zIndex: OVERLAY_Z
        }}
      />
    )
  }

  return (
    <>
      <svg
        style={{ position: 'fixed', inset: 0, width: '100vw', height: '100vh', pointerEvents: 'none', zIndex: OVERLAY_Z }}
      >
        <defs>
          <mask id="tour-spotlight-mask">
            <rect width="100%" height="100%" fill="white" />
            <rect
              x={hole.left}
              y={hole.top}
              width={hole.right - hole.left}
              height={hole.bottom - hole.top}
              rx={10}
              ry={10}
              fill="black"
            />
          </mask>
        </defs>
        <rect width="100%" height="100%" fill={OVERLAY_BG} mask="url(#tour-spotlight-mask)" />
      </svg>
      <div
        style={{
          position: 'fixed',
          top: hole.top,
          left: hole.left,
          width: hole.right - hole.left,
          height: hole.bottom - hole.top,
          borderRadius: 10,
          pointerEvents: 'none',
          zIndex: OVERLAY_Z + 1
        }}
      />
    </>
  )
}
